module.exports = __webpack_public_path__ + "img/yacht-6.f5e0c5d7.jpg";